import * as THREE from 'three'
import { depthAtView, type DepthFrame } from '../depth/depth-frame'

/**
 * The world point the screen centre is looking at, taken from depth rather than
 * from hit-test: a box has to land on the surface the demo actually sensed, and
 * hit-test would land it on ARCore's plane instead.
 */

const invProjection = new THREE.Matrix4()
const clipPoint = new THREE.Vector4()

/** Writes the world point to `out`. Returns false when the centre has no depth. */
export function viewCentreWorld(depth: DepthFrame, out: THREE.Vector3): boolean {
  const distance = depthAtView(depth, 0.5, 0.5)
  if (distance <= 0) return false

  invProjection.fromArray(depth.view.projectionMatrix).invert()
  const point = clipPoint.set(0, 0, -1, 1).applyMatrix4(invProjection)
  const invW = 1 / point.w
  const clip = point.z * invW
  if (clip === 0) return false

  const scale = -1 / clip
  const vx = point.x * invW * scale * distance
  const vy = point.y * invW * scale * distance
  const vz = -distance

  const world = depth.view.transform.matrix
  out.set(
    world[0]! * vx + world[4]! * vy + world[8]! * vz + world[12]!,
    world[1]! * vx + world[5]! * vy + world[9]! * vz + world[13]!,
    world[2]! * vx + world[6]! * vy + world[10]! * vz + world[14]!
  )
  return true
}
